
import { useState } from "react";
import { Grid } from "@mui/material";
import { InputDePassword } from "../../home/components";
import { BotonesAndCargando } from "../../components/botones";
import { actualizarPassword } from "../../../services";


import Swal from "sweetalert2";

const initUser = {
    claveAntigua: "",
    password: "",
    confirmarClave: "",
};



export const FormCambiarPassword = () => {


    const [ cambioClave, setCambioClave ] = useState( initUser );
    const { claveAntigua, password, confirmarClave } = cambioClave;
    const [cargando, setCargando] = useState(false);


    
    const handleInputChange = ({ target }) => {
        setCambioClave({
            ...cambioClave,
            [target.name]: target.value
        });
    }

    const handleCambioClave = async(e) => {
        e.preventDefault();
        if( password !== confirmarClave ) {
            Swal.fire('Error', 'Las Claves Deben de Ser Iguales', 'error');
            return;
        }
        if( password.trim().length < 5){
            Swal.fire('Error', 'El Password debe ser mayor a 5 digitos', 'error');
            return;
        }

        setCargando(true);
        const resp = await actualizarPassword(cambioClave);
        setCargando(false);
        if( resp ){ setCambioClave( initUser ); }
    }


    return (

        <form style={{marginTop:40, width:'100%'}} onSubmit={ handleCambioClave } >
            <Grid container sx={{ display:'flex', flexDirection:'column', width:'100%' }}>
                <Grid item xs={12} sx={{display:"flex", justifyContent:"center"}}>
                    <Grid item xs={12} sm={8} md={6}>
                        <InputDePassword size='small' 
                            value={claveAntigua}
                            name='claveAntigua'
                            placeholder={'Clave Anterior'} 
                            onChangeInput={ handleInputChange } 
                        /> 
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{display:"flex", justifyContent:"center", mt:3}}>
                    <Grid item xs={12} sm={8} md={6}>
                        <InputDePassword size='small' 
                            value={password}
                            name='password'
                            placeholder={'Nuevo Password'} 
                            onChangeInput={ handleInputChange } 
                        /> 
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{display:"flex", justifyContent:"center", mt:3}}>
                    <Grid item xs={12} sm={8} md={6}>
                        <InputDePassword size='small' 
                            value={confirmarClave}
                            name='confirmarClave'
                            placeholder={'Confirmar Password'} 
                            onChangeInput={ handleInputChange } 
                        /> 
                    </Grid>
                </Grid>
            </Grid>


            <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={8} md={6}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Cambiar Password'
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>
        </form>

    )
}
